import axiosOpenClient from "./axiosOpenClient";

/**
 * Send a feature request to the API with optional attachment
 * @param formData - FormData containing email, name, message, and optional attachment
 */
export const requestFeature = async (formData: FormData) => {
  try {
    // Use FormData directly without stringifying for multipart/form-data support
    const response = await axiosOpenClient.post(
      "/public/api/request-feature",
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}
  